import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  Box,
  SwipeableDrawer,
} from '@mui/material'
import React, { Fragment } from 'react'
import 'dayjs/locale/vi'
import TextField from '@mui/material/TextField'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'

import { WORK_STATUS } from '../../utils/constants'

const SearchAdvance = ({
  openSearchAdvance,
  handleOpenSearchAdvance,
  handleCloseSearchAdvance,
  filter,
  setFilter,
}) => {
  const handleChangeFromDate = newValue => {
    setFilter({
      ...filter,
      fromDateIssue: newValue.format('YYYY-MM-DD'),
    })
  }
  const handleChangeToDate = newValue => {
    setFilter({
      ...filter,
      toDateIssue: newValue.format('YYYY-MM-DD'),
    })
  }
  const handleApply = () => {
    setFilter({ page: 0, size: 10, ...filter })
    handleCloseSearchAdvance()
  }
  const handleReset = () => {
    setFilter({
      ...filter,
      fromDateIssue: null,
      toDateIssue: null,
    })
  }
  const list = (
    <>
      <Box
        sx={{
          width: '335px',
          pt: '50px',
          minHeight: '500px',
          '& ul': {
            position: 'unset',
            marginBottom: '70px',
          },
        }}
        role="presentation">
        <div className="px-5 mt-[50px] search-advance">
          <div className="min-h-[calc(100vh-90px)]">
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Ngày ban hành từ ngày - đến ngày
            </p>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <div className="flex gap-3">
                <div className="mt-4">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    value={filter?.fromDateIssue}
                    onChange={handleChangeFromDate}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                    initialFocusedDate={null}
                  />
                </div>
                <div className="mt-4">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    // minDate={minDate}

                    value={filter?.toDateIssue}
                    onChange={handleChangeToDate}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                  />
                </div>
              </div>
            </LocalizationProvider>
          </div>
        </div>
      </Box>
      <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
        <button
          onClick={handleReset}
          className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]">
          <div className="font-semibold text-[14px] leading-[22px] px">
            Nhập lại
          </div>
        </button>
        <button
          onClick={handleApply}
          className="text-center w-1/2 block text-white rounded bg-primary py-[16px] ml-[5px]">
          <div className="font-semibold text-[14px] leading-[22px] px">
            Áp dụng
          </div>
        </button>
      </div>
    </>
  )
  return (
    <Fragment>
      <SwipeableDrawer
        anchor={'right'}
        open={openSearchAdvance}
        onOpen={handleOpenSearchAdvance}
        onClose={handleCloseSearchAdvance}
        disableSwipeToOpen={false}>
        {list}
      </SwipeableDrawer>
    </Fragment>
  )
}

export default SearchAdvance
